var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'tsyringe';
import { services } from './Services.js';
import { getArray } from './qbo-json.js';
import { RestApiService } from './RestApiService.js';
import { ValidateToken } from './IValidate.js';
/**
 * A validator for a US zip code.
 */
let ZipCodeValidator = class ZipCodeValidator {
    constructor() {
        this.message = 'Zip code is invalid';
        this.selector = '.zipcode';
    }
    validate(input) { return Promise.resolve(true); }
    ;
    connect(form) { }
    ;
    disconnect() { }
    ;
};
ZipCodeValidator = __decorate([
    injectable()
], ZipCodeValidator);
export { ZipCodeValidator };
services.container.register(ValidateToken, { useClass: ZipCodeValidator });
/**
 * A validator for an email address.
 */
let EmailValidator = class EmailValidator {
    constructor() {
        this.message = 'Email is invalid';
        this.selector = '.email';
    }
    validate(input) { return Promise.resolve(true); }
    ;
    connect(form) { }
    ;
    disconnect() { }
    ;
};
EmailValidator = __decorate([
    injectable()
], EmailValidator);
export { EmailValidator };
services.container.register(ValidateToken, { useClass: EmailValidator });
let ExistsValidator = class ExistsValidator {
    constructor() {
        this.message = 'This value does not appear to exist.';
        this.selector = '[data-exists]';
    }
    connect(form) { }
    ;
    disconnect() { }
    ;
    async validate(input) {
        var url = input.getAttribute('data-exists');
        if (!url)
            return false;
        var path = input.getAttribute('data-exists-path');
        const service = services.container.isRegistered(url) ? services.container.resolve(url) : new RestApiService(url);
        if (input instanceof HTMLInputElement || input instanceof HTMLSelectElement || input instanceof HTMLTextAreaElement) {
            const response = await service.fetch(path, { value: input.value });
            const json = getArray(response);
            if (json == null)
                return false;
            return json.length > 0;
        }
        return false;
    }
    ;
};
ExistsValidator = __decorate([
    injectable()
], ExistsValidator);
export { ExistsValidator };
services.container.register(ValidateToken, { useClass: ExistsValidator });
